import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  public swipeEvent = new Subject<any>();
  public viewPrivacyObservable$ = this.swipeEvent.asObservable();
  public changeProductModeEvent = new Subject<any>();
  public changeJwtEvent = new Subject<any>();
  public changeJwtObservable$ = this.changeJwtEvent.asObservable();
  public wsConnected = new Subject<any>();
  public wsConnectedObservable$ = this.wsConnected.asObservable();

  constructor() {
  }

  emitSwipeEvent(data: string) {
    this.swipeEvent.next(data);
  }

  emitChangeJwt(){
    this.changeJwtEvent.next();
  }

  emitWsConnected(){
    this.wsConnected.next();
  }
}
